var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-inline-block"},_vm._l((_vm.value),function(tag,index){return _c('b-badge',{key:index,staticClass:"mr-50"},[_c('feather-icon',{staticClass:"mr-25",attrs:{"icon":"TagIcon"}}),_c('span',[_vm._v(_vm._s(tag))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }